import React from 'react';
import CustomerQuery from 'components/Tvendo/BusinessPartner/Queries/Customer';

export default function () {
  return <CustomerQuery />;
}
